// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "CalendarEvent" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ScheduledEmailType } from "./scheduled-email-type.enum.gen";
import { EmailStatus } from "./email-status.enum.gen";
import { EmailTeamScope } from "./email-team-scope.enum.gen";

export const CalendarEventGenShape = z.strictObject({
  id: z.string(),
  type: z.enum(ScheduledEmailType),
  tag: z.string(),
  due: z.string(),
  created: z.string(),
  status: z.enum(EmailStatus),
  info: z.string().optional(),
  scope: z.enum(EmailTeamScope),
  rangeStart: z.string(),
  rangeEnd: z.string(),
});
